import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row gx-3" }
const _hoisted_4 = { class: "col-md-4 mb-3" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-md-4 mb-3" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "col-md-4 mb-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = { class: "col-md-4 mb-3" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-md-4 mb-3" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-md-4 mb-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-4 mb-3" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "col-md-4 mb-3" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "col-md-6 mb-3" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "col-md-6 mb-3" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-md-12 mb-3" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_32 = {
  key: 0,
  class: "alert txt-danger border-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_33 = { class: "border border-primary" }
const _hoisted_34 = { class: "p-3" }
const _hoisted_35 = { class: "col-md-5 mb-2" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = ["onUpdate:modelValue", "onChange"]
const _hoisted_38 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_39 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_40 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_41 = {
  key: 3,
  class: "invalid-feedback"
}
const _hoisted_42 = { class: "col-md-5 mb-2" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_46 = { class: "col-md-2 mb-2" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "col-md-12 mt-3" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_format_montant = _resolveDirective("format-montant")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("h3", { class: "text-black fw-semibold" }, "Ajouter une créance")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "creanceForm",
        onSubmit: _ctx.addCreance,
        "validation-schema": _ctx.creanceSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date de la créance "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "date",
                  type: "date",
                  value: _ctx.getCurrentDateTime(),
                  readonly: "",
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "date",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Client "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "client",
                  modelValue: _ctx.client,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.clientOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner le client",
                      label: "label",
                      "track-by": "label",
                      onSelect: _ctx.onClientSelect
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "client",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Commandes client "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "commandes" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      mode: "tags",
                      options: _ctx.commandesOptions,
                      "preserve-search": true,
                      searchable: true,
                      placeholder: "Sélectionner les commandes",
                      label: "label",
                      valueProp: "value",
                      "onUpdate:modelValue": _ctx.onCommandeSelect,
                      disabled: !_ctx.client || _ctx.commandesOptions.length === 0,
                      "close-on-select": false
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "commandes",
                  class: "text-danger"
                }),
                (_ctx.commandesSelectionnees.length > 0)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.commandesSelectionnees.length) + " commande(s) sélectionnée(s) ", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Références des Commandes "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  type: "text",
                  name: "refCommande",
                  modelValue: _ctx.refCommande,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refCommande) = $event)),
                  readonly: "",
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "refCommande",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Montant total des Commandes "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("input", {
                  type: "text",
                  name: "montantTotalCommandes",
                  value: _ctx.separateur(parseInt(_ctx.montantFacture.replace(/\s+/g, '') || 0)),
                  readonly: "",
                  class: "form-control shadow-none fs-md-15 text-black bg-light"
                }, null, 8, _hoisted_15),
                _createVNode(_component_ErrorMessage, {
                  name: "montantTotalCommandes",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Montant Réglé "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createElementVNode("input", {
                  type: "text",
                  name: "montantRegle",
                  value: _ctx.separateur(parseInt(_ctx.montantRegle.replace(/\s+/g, '') || 0)),
                  readonly: "",
                  class: "form-control shadow-none fs-md-15 text-black bg-light"
                }, null, 8, _hoisted_18),
                _createVNode(_component_ErrorMessage, {
                  name: "montantRegle",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Montant total de la créance "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "montant",
                  value: _ctx.montant,
                  readonly: "",
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, _hoisted_21), [
                  [_directive_format_montant]
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "montant",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Durée de créance en jours "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dureeCreance",
                  type: "number",
                  modelValue: _ctx.dureeCreance,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dureeCreance) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer la durée en jours"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dureeCreance",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Mode de paiement initialement prévu "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "modeReglement",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.modeReglementOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner un mode de paiement",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "modeReglement",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, [
                  _createTextVNode(" Nombre d'échéances / Echéancier "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  type: "number",
                  name: "nbreEcheance",
                  modelValue: _ctx.nbreEcheance,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nbreEcheance) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "nbreEcheance",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-1" }, " Autres informations ", -1)),
                _createVNode(_component_Field, {
                  name: "autresinfos",
                  as: "textarea",
                  cols: "15",
                  rows: "3",
                  placeholder: "Entrer les autres informations",
                  class: "form-control shadow-none rounded-0 text-black"
                }, {
                  default: _withCtx(({ field }) => [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control shadow-none rounded-0 text-black",
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, null, 8, _hoisted_30), [
                      [_vModelText, field.value]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "autresinfos",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.nbreEcheance > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_ctx.montantTotalEcheance !== _ctx.montant && _ctx.montantTotalEcheance > 0 && _ctx.montant > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _cache[15] || (_cache[15] = [
                        _createElementVNode("i", {
                          "data-name": "clock",
                          "data-tags": "time,watch,alarm",
                          "data-type": "clock",
                          class: "vue-feather vue-feather--clock"
                        }, [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            class: "feather feather-clock vue-feather__content"
                          }, [
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "10"
                            }),
                            _createElementVNode("polyline", { points: "12 6 12 12 16 14" })
                          ])
                        ], -1),
                        _createElementVNode("p", null, "Le montant total des échéances doit être égal au montant total de la créance, donc revoir la répartition", -1),
                        _createElementVNode("button", {
                          class: "btn-close",
                          type: "button",
                          "data-bs-dismiss": "alert",
                          "aria-label": "Close"
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_33, [
                    _cache[19] || (_cache[19] = _createElementVNode("div", {
                      class: "row d-flex align-items-center justify-content-between fw-bold py-2",
                      style: {"background-color":"#0a59a4"}
                    }, [
                      _createElementVNode("div", { class: "col-md-12" }, [
                        _createElementVNode("h3", { class: "fs-4 text-white" }, "Échéances")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between" }, [
                        _createElementVNode("div", { class: "col-md-5" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                            _createTextVNode("Date Échéance "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ])
                        ]),
                        _createElementVNode("div", { class: "col-md-5" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                            _createTextVNode("Montant "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ])
                        ]),
                        _createElementVNode("div", { class: "col-md-2" }, [
                          _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Actions")
                        ])
                      ], -1)),
                      _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.echeances, (echeance, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "row",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((echeance.dateEcheance) = $event),
                                name: "dateikken",
                                type: "date",
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "Saisir la date de l'échéance",
                                onChange: ($event: any) => (_ctx.validateEcheances(index))
                              }, null, 40, _hoisted_37), [
                                [_vModelText, echeance.dateEcheance]
                              ]),
                              (_ctx.valideteRowEcheance(echeance.dateEcheance))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, " La date échéance est obligatoire. "))
                                : _createCommentVNode("", true),
                              (_ctx.echeanceErrors[index]?.duplicate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Cette date est déjà utilisée. "))
                                : _createCommentVNode("", true),
                              (_ctx.echeanceErrors[index]?.order)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, " La date doit être supérieure à la précédente. "))
                                : _createCommentVNode("", true),
                              (_ctx.echeanceErrors[index]?.beforeFacture)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, " La date doit être postérieure à la date de facture. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((echeance.montant) = $event),
                                name: "montant",
                                type: "text",
                                class: "form-control shadow-none fs-md-15 text-black",
                                placeholder: "Entrer le montant"
                              }, null, 8, _hoisted_44), [
                                [_vModelText, echeance.montant],
                                [_directive_format_montant]
                              ]),
                              (_ctx.valideteRowEcheance(echeance.montant))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, " Le montant est obligatoire. "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("button", {
                              class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeRowEcheance(index))
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                            ]), 8, _hoisted_47)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("button", {
                  ref: "submitButton",
                  class: "btn btn-success me-3",
                  type: "submit",
                  disabled: _ctx.nbreEcheance <= 0 || _ctx.isDisable
                }, " Ajouter une créance ", 8, _hoisted_50),
                _createVNode(_component_router_link, {
                  to: "/creances/liste-creances",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, "Annuler", -1)
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}